import Cookies from "js-cookie";

const TokenKey = "xlg-token";

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  // console.log(token.length);
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export { Cookies };
